import { render, staticRenderFns } from "./u-sitemap-outlined.vue?vue&type=template&id=fa0d8bd0&scoped=true"
import script from "./u-sitemap-outlined.vue?vue&type=script&lang=js"
export * from "./u-sitemap-outlined.vue?vue&type=script&lang=js"
import style0 from "./u-sitemap-outlined.vue?vue&type=style&index=0&id=fa0d8bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0d8bd0",
  null
  
)

export default component.exports